import { useState, useEffect } from 'react';
import type { MarketStatusEntry } from '@/types/bot';
import { marketStatusAPI } from '@/services/api';

export function useMarketStatus(refreshInterval = 60_000) {
  const [markets, setMarkets] = useState<MarketStatusEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchStatus() {
      try {
        const data = await marketStatusAPI.getStatus();
        if (mounted) {
          setMarkets(data);
          setLoading(false);
        }
      } catch {
        if (mounted) setLoading(false);
      }
    }

    fetchStatus();
    const id = setInterval(fetchStatus, refreshInterval);
    return () => { mounted = false; clearInterval(id); };
  }, [refreshInterval]);

  return { markets, loading };
}
